export default __webpack_public_path__ + "static/media/bookmark.73de84cf.svg";